/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Conversations icon.
 */
export const ICON_CAPABILITY_CONVERSATIONS = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40.9033 9.375L39.0283 13.5L37.1533 9.375L33.0283 7.5L37.1533 5.625L39.0283 1.5L40.9033 5.625L45.0283 7.5L40.9033 9.375Z"
      fill="#1D9BE2"
    />
    <path
      d="M41.5923 16.0639L42.7577 13.5L43.9231 16.0639L46.487 17.2294L43.9231 18.3948L42.7577 20.9587L41.5923 18.3948L39.0283 17.2294L41.5923 16.0639Z"
      fill="#1D9BE2"
    />
    <path
      clipRule="evenodd"
      d="M3 18.1563C3 11.4425 8.44253 6 15.1562 6H26.3001C27.1285 6 27.8001 6.67157 27.8001 7.5C27.8001 8.32843 27.1285 9 26.3001 9H15.1562C10.0994 9 6 13.0994 6 18.1563V26.3776C6 27.206 5.32843 27.8776 4.5 27.8776C3.67157 27.8776 3 27.206 3 26.3776V18.1563Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M43.5 29.8437C43.5 36.5575 38.0575 42 31.3438 42H21.3964C20.568 42 19.8964 41.3284 19.8964 40.5C19.8964 39.6716 20.568 39 21.3964 39H31.3438C36.4006 39 40.5 34.9006 40.5 29.8437V27.8845C40.5 27.0561 41.1716 26.3845 42 26.3845C42.8284 26.3845 43.5 27.0561 43.5 27.8845V29.8437Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.99997 18.7812C8.99997 15.0361 12.036 12 15.7812 12H30.7187C34.4639 12 37.5 15.0361 37.5 18.7812V29.2188C37.5 32.9639 34.4639 36 30.7187 36H17.0022C14.6304 36.108 12.6231 36.9049 10.7651 37.9444C9.03429 38.9127 7.33975 37.2752 7.95491 35.3898C8.54741 33.5737 8.9597 31.3492 8.99997 28.4611V27.5171C8.99888 27.4362 8.99751 27.3549 8.99585 27.273L8.99997 27.2774V18.7812ZM16.5 19.5C16.5 18.6716 17.1715 18 18 18H28.5C29.3284 18 30 18.6716 30 19.5C30 20.3284 29.3284 21 28.5 21H18C17.1715 21 16.5 20.3284 16.5 19.5ZM16.5 24C16.5 23.1716 17.1715 22.5 18 22.5H28.5C29.3284 22.5 30 23.1716 30 24C30 24.8284 29.3284 25.5 28.5 25.5H18C17.1715 25.5 16.5 24.8284 16.5 24ZM18 27C17.1715 27 16.5 27.6716 16.5 28.5C16.5 29.3284 17.1715 30 18 30H22.5C23.3284 30 24 29.3284 24 28.5C24 27.6716 23.3284 27 22.5 27H18Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
  </svg>
);
